import { ActionTree } from 'vuex';
import { ProyectoState } from './state';
import axios, { AxiosResponse } from 'axios';

const API_URL = process.env.VUE_APP_URL_BACKEND;

const actions: ActionTree<ProyectoState, any> = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async enviarAsesoria({ commit }, payload: any) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        
        try {
            const { nombre, apellidos, celular, correo, acepta_politica } = payload; // Obténer los datos del estado o parámetros necesarios
            
            // Construir el JSON de solicitud
            const requestData = { nombre, apellidos, celular, correo, acepta_politica };

            const response: AxiosResponse<any> = await axios.post(`${API_URL}api/auth/recibir-asesoria/`, requestData);
            
            commit("ADD_ASESORIA", requestData); 
            return response.data;

        }  catch (error: any) {
                            if (axios.isAxiosError(error)) {
                                commit("SET_ERROR", error.response?.data || error.message);
                                console.error("Error en enviarAsesoria:", error.response?.data || error.message);
                            } else {
                                commit("SET_ERROR", "Error desconocido");
                                console.error("Error inesperado:", error);
                            }
                            throw error;
        } finally {
                commit("SET_LOADING", false);
        }
    },
    async agendarCita({ commit }, payload: any){
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);

        try {
            const { nombre, apellidos, celular, correo, fecha, hora, acepta_politica } = payload; // Obtnener los datos del estado o parámetros necesarios
            
            // Construir el JSON de la solicitud
            const requestData = { nombre, apellidos, celular, correo, fecha, hora, acepta_politica };

            const response: AxiosResponse<any> = await axios.post(`${API_URL}api/auth/agendar-cita/`, requestData);

            commit("ADD_ASESORIA", requestData);
            return response.data;
        }   catch (error: any) {
                            if (axios.isAxiosError(error)){
                                commit("SET_ERROR", error.response?.data || error.message);
                                console.error("Error en Generar Cita:", error.response?.data || error.message);
                            } else {
                                commit("SET_ERROR", "Error desconocido");
                                console.error("Error inesperado:", error);
                            }
                            throw error;
        } finally {
                commit("SET_LOADING", false);
        }
    },
    // Obtener el PDF de política de tratamiento de datos personales de instelmecsas desde el backend
    async fetchTermsPdf({ commit }) {
        try {
            const response = await axios.get(`${API_URL}politicas-tratamiento-instelmecsas/pdf/`);

            // Crear una URL en el estado global
            const pdfUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf'}));

            // Guardamoms la URL en el estado global
            commit('setTermsPdfUrl', pdfUrl);

            return pdfUrl;
        } catch (error) {
            console.error('Error obteniendo el PDF de política de tratamiento de datos personales:', error);
            throw error;
        }
    },
};


export default actions;